export const FIELDS = {

  ID: 'id',
  NAME: 'name',
  TRACKING_URL: 'trackingUrl',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
};